import { _, isAuthorized, piloteAndAuditor } from '@/router/routing'
import MainApp from '@/components/MainApp.vue'
import type { Route, RouteConfig } from 'vue-router'
import { administrationRoutes } from '@/contexts/administration/Administration.routes'

// Build tools mother route for wheel menu (also used in main-sidebar when isPublic is true => administrate menu)

export const adminRoutes: RouteConfig[] = [
  {
    path: '/admin',
    name: 'admin',
    component: MainApp,
    meta: {
      title: _('Administrate'),
      icon: 'tools',
      dummy: true,
      requires_role: piloteAndAuditor,
      is_authorized: (route: Route) => isAuthorized(route),
    },
    children: administrationRoutes,
  },
]
